import { render, staticRenderFns } from "./TagOptionsInput.vue?vue&type=template&id=638ec7d4&scoped=true&"
import script from "./TagOptionsInput.vue?vue&type=script&lang=js&"
export * from "./TagOptionsInput.vue?vue&type=script&lang=js&"
import style0 from "./TagOptionsInput.vue?vue&type=style&index=0&id=638ec7d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ec7d4",
  null
  
)

export default component.exports